import LocalStorage from './LocalStorage'

const featureKey = 'hasShown'
const validKeys = new Set(['welcomeModal'])

class HasShown {
    static setHasShown(key, val=true) {
        try {
            const hasShown = LocalStorage.read(featureKey)
            if (!validKeys.has(key)) throw Error(`HasShown error: "${key}" is
                not declared as valid key.`)
            hasShown[key] = val
            LocalStorage.write(featureKey, hasShown)
        } catch(e) {
        }
    }

    static hasShown(key) {
        try {
            const hasShown = LocalStorage.read(featureKey)
            if (!(key in hasShown)) return false
            else return hasShown[key]
        } catch(e) {
            return true
        }
    }
}

export default HasShown



// WEBPACK FOOTER //
// ./src/lib/LocalStorage/HasShown.js